<!--
@deprecated This component does not have a route setup and there is no navigation path to it.
-->
<div class="invoices-parents">
  <table class="page-table">
    <tr>
      <td colspan="3">
        <kendo-grid style="width: 100%; height: 100%;" class="statements-parents-table"
                    #statementsparentsDataTable
                    [kendoGridBinding]="parents"
                    [loading]="loading"
                    [pageSize]="pageSize"
                    [height]="itemHeight"
                    [resizable]="true"
                    [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext
                    }"
                    [sortable]="true"
                    [sort]="sort"
                    [scrollable]="true"
                    (pageChange)="pageChange($event)"
                    [selectable]="{
                      mode: 'multiple',
                      checkboxOnly: false
                    }"
                    filterable="menu"
                    (selectionChange)="allRowsSelected($event)"
                    [rowSelected]="isRowSelected"
                    [skip]="skip"
                    [kendoGridSelectBy]="selectionKey"
                    [selectedKeys]="selectedKeys"
                    [reorderable]="true">
          <ng-template kendoGridToolbarTemplate>
            <kendo-grid-column-chooser style="float:right"></kendo-grid-column-chooser>
          </ng-template>
          <kendo-grid-checkbox-column [width]="55" [showSelectAll]="true" [reorderable]="false"
                                      [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate>
              <input class="k-checkbox" id="selectAllCheckboxId" kendoGridSelectAllCheckbox
                     [state]="selectAllState"
                     (selectAllChange)="allRowsSelected($event)">
              <label class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
            </ng-template>
          </kendo-grid-checkbox-column>

          <kendo-grid-column field="id" title="Parent Customer" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="siteNumber" title="Parent Store" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="siteName" title="Description" [width]="150">
          </kendo-grid-column>

        </kendo-grid>
      </td>
    </tr>
    <tr>
      <td>
        <table class="b-button-bar">
          <tr>
            <td>
              <app-mcl-button text="< Back To Statement Selection" primary="true" (click)="backClicked()" [disabled]="false">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="Next To Invoice Search >" primary="true" (click)="nextClicked()" [disabled]="nextDisabled">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="Cancel" primary="true"  (click)="cancelClicked()" [disabled]="true">
                Cancel
              </app-mcl-button>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <div kendoDialogContainer></div>
</div>
